export const formatApiError = (error, fallback) => {
  const detail = error?.response?.data?.detail;
  if (!detail) return fallback;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => {
      const msg = (e?.msg || '').replace(/^Value error, /, '');
      const field = { username: 'Gebruikersnaam', first_name: 'Voornaam', last_name: 'Achternaam', password: 'Wachtwoord', email: 'E-mail' }[e?.loc?.[e.loc.length - 1]];
      return field && msg ? `${field}: ${msg}` : msg;
    }).filter(Boolean).join(' ') || fallback;
  }
  return detail.msg || fallback;
};
